<template>
  <section class="container mx-auto">
    <h2 class="text-center" data-aos="fade-in">team</h2>
    <div
      class="flex justify-center my-10 mx-auto max-w-screen-lg 2xl:max-w-screen-xl"
    >
      <swiper-images-component
        :items="items.slice(0, Math.floor(items.length / 2))"
        :swiperProps="swiperProps"
        :overlay="true"
      />
    </div>
    <div
      class="flex justify-center my-10 mx-auto max-w-screen-lg 2xl:max-w-screen-xl"
    >
      <swiper-images-component
        :items="items.slice(Math.floor(items.length / 2))"
        :swiperProps="swiperProps"
        :overlay="true"
        dir="rtl"
      />
    </div>
  </section>
</template>

<script>
import swiperImagesComponent from "./swiperImagesComponent.vue"
import { getScreenSizeByName } from "@/utils"
import { shuffle } from "lodash"

export default {
  name: "teamComponent",
  components: { swiperImagesComponent },
  computed: {
    items() {
      return shuffle([
        {
          src: require("@/assets/team/msk.png"),
          name: "MASK",
          position: "CEO Founder",
          href: "https://discord.com/users/MASK#3348",
          description:
            "Software expert, i worked on several new and interesting technologies. i hold the position of CTO IT in Standard Intelligence GmBh Co. specialize in managing technological projects.",
        },
        {
          src: require("@/assets/team/Equalizer.png"),
          name: "Equalizer",
          position: "CEO Founder",
          href: "https://discord.com/users/Equalizer#9593",
          description:
            "expert in the field of crypto and marketing and a manager for several different projects. I specialize in organizing and managing projects and increasing the work efficiency to the highest level.",
        },
        {
          src: require("@/assets/team/mai.png"),
          name: "mai sensi",
          position: "Artist",
          href: "https://www.instagram.com/mai_sensi",
          description:
            "Professional digital artist. drawing, painting and other arts are my passion my expert is in drawing children books and educational books. I also specialize in drawing unique figures on woodwor",
        },
        {
          src: require("@/assets/team/macode.png"),
          name: "MAcode",
          position: "Developer",
          href: "https://discord.com/users/macode#4890",
          description:
            "Full-stack web developer, I have created the front end of Argons website with the latest technologies to make browsing easy, fun and convenient.",
        },
        {
          src: require("@/assets/team/Msah.png"),
          name: "Msah",
          position: "Artist",
          href: "",
          description:
            "Creator of the ARGONS characters. Professional painter with over 30 years of experience. painted many pieces well known in several countries. specialize in merging different schools of art in one painting.",
        },
        {
          src: require("@/assets/team/XAbd.png"),
          name: "XAbd",
          position: "Graphic Designer",
          href: "",
          description:
            "Professional digital artist. works in an advertisement department for a telecom company. greatly experienced in graphic design programs.",
        },
        {
          src: require("@/assets/team/IMG_1515.png"),
          name: "Sla-man",
          position: "Gaming Musician",
          href: "https://open.spotify.com/artist/7dUvRrykxu6s7QU76x5OEs",
          description:
            "music composer. specialize in making music tracks for video games and short films",
        },
        {
          src: require("@/assets/team/faouzi.png"),
          name: "Faouzi",
          position: "3D animation",
          href: "https://www.youtube.com/channel/UCR0TRIOcj5kZhkvKa-4x9Ew",
          description:
            "I am director and a theater actor, i work in the digital field of 2D and 3D and also i design 3D characters for video games, anything related to work motivates me to come up with great ideas.",
        },
        {
          src: require("@/assets/team/Dana.png"),
          name: "Dana Ramoni",
          position: "Media Creator",
          href: "https://www.linkedin.com/in/dana-ramoni-913b4823",
          description:
            "CEO of Stumptown Pro Seo ,Stumptown Pro Seo is a local marketing company that focuses on helping local businesses reach customers by the use of local, mobile, and social marketing.",
        },
      ])
    },
    swiperProps() {
      const maxPerView = this.items.length > 4 ? 4 : this.items.length

      return {
        slidesPerView: 2,
        spaceBetween: 30,
        breakpoints: {
          [getScreenSizeByName("sm")]: { slidesPerView: 1 },
          [getScreenSizeByName("md")]: { slidesPerView: 2 },
          [getScreenSizeByName("lg")]: { slidesPerView: maxPerView },
        },
      }
    },
  },
}
</script>
